import React from 'react';
import Navigation from '../components/Navigation';
import SocialShareBar from '../components/SocialShareBar';

import '../styles/App.css';


const BasePage = (props) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="d-flex flex-column min-vh-100">
        <header className="bg-primary text-white shadow-sm position-relative overflow-hidden">
            <div className="container py-3 position-relative">
                <div className="text-center">
                    <h1 className="display-5 fw-bold mb-2 text-white d-flex align-items-center justify-content-center">
                        <i className="bi bi-airplane-fill me-3" style={{fontSize: '2rem'}}></i>
                        <a className="text-white text-decoration-none" href="/">Onward Flight Ticket</a>
                    </h1>
                    <p className="lead mb-0 text-white-50">Free Dummy Ticket {currentYear}</p>
                </div>
            </div>
            <Navigation />
        </header>

        <div className="container flex-grow-1">
        <div className="row">
          <div className="col">
            {props.children}
          </div>
        </div>
      </div>

        <footer className="bg-light py-4 mt-auto">
            <div className="container">
                <div className="row mb-3">
                    <div className="col-12">
                        <SocialShareBar />
                    </div>
                </div>
                <div className="footer-copyright text-center">© {currentYear} Copyright:
                    <div className="row justify-content-center mt-2">
                        <div className="col">
                            <a href="/">
                            onwardflightticket.com
                            </a>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            <p className="mb-2">For any requests contact: <a href="mailto:onwardflightticket@gmail.com">onwardflightticket@gmail.com</a></p>
                        </div>
                    </div>
                    <div className="row justify-content-center mt-2">
                        <div className="col-md-2">
                            <a href="/terms">
                                Terms of service
                            </a>
                        </div>
                        <div className="col-md-2">
                            <a href="/privacy-policy">
                                Privacy Policy
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
  );
}

export default BasePage;
